'use client';

import { useMutation } from '@tanstack/react-query';

import { useWorkbenchConfig } from '@/components/Contexts/WorkbenchConfigContext';
import { useApiClient } from '@/hooks/useApiClient';

interface SubmitCommenterParams {
  name: string;
  email?: string;
}

interface SubmitCommenterResult {
  userName: string;
  email: string | null;
}

/** Saves the reviewer's name (and optional email) as their commenter. */
export function useSubmitCommenter() {
  const apiClient = useApiClient();
  // The site the commenter is written on travels inside the sealed context.
  const { sealedContext } = useWorkbenchConfig();

  return useMutation({
    mutationFn: (params: SubmitCommenterParams) =>
      apiClient
        .post<SubmitCommenterResult>('api/commenter', {
          ctx: sealedContext,
          name: params.name,
          email: params.email,
        })
        .then((r) => r.data),
  });
}
